<template>
  <div class="recovery-grade-status-card">
    <div class="recovery-grade-status">
      <div class="header">
        <h2>{{ title }}</h2>
        <div class="subtitle">{{ subtitle }}</div>
      </div>

      <div class="grades">
        <div class="grade-status-icon grade-color-a">A</div>
        <div class="grade-status-icon grade-color-b">B</div>
        <div class="grade-status-icon grade-color-c">C</div>
        <div class="grade-status-icon grade-color-d">D</div>
        <div class="grade-status-icon grade-color-e">E</div>
        <div class="grade-status-icon grade-color-f">F</div>
      </div>

      <div class="body">
        <h4>{{ legend }}</h4>
        <div class="description">
          {{ description }}
        </div>
      </div>

      <button @click="scrollTop">Move to top</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RecoveryGradeStatus',
    props: {
      title: {
        type: String,
      },
      subtitle: {
        type: String,
      },
      legend: {
        type: String,
      },
      description: {
        type: String,
      },
    },
    methods: {
      scrollTop() {
        document.getElementById("mby-top").scrollIntoView({
          behavior: "smooth",
        });
        this.$store.dispatch("logSimpleEvent", {
          eventName: "Back to Top Link",
          eventProperties: { Click: true },
        });
      },
    },
  }
</script>

<style scoped>
.recovery-grade-status-card {
  padding: 40px 0px;
  background: rgba(250, 250, 250, 0.93);
  max-width: 1216px;
  width: 100%;
}

.recovery-grade-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.recovery-grade-status .header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.recovery-grade-status .header h2 {
  font-family: "WWF",sans-serif;
  font-size: 48px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.recovery-grade-status .header .subtitle {
  color: #757575;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: capitalize;
}

.recovery-grade-status .grades {
  display: flex;
  gap: 40px;
}

.recovery-grade-status .grades .grade-status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 140px;
  background-color: #757582;
  font-family: "WWF",sans-serif;
  font-size: 2em;
  color: #FFFFFF;
}

.recovery-grade-status .grades .grade-status-icon.grade-color-a {
  background-color: #319362;
}

.recovery-grade-status .grades .grade-status-icon.grade-color-b {
  background-color: #87D178;
}

.recovery-grade-status .grades .grade-status-icon.grade-color-c {
  background-color: #EFBB3A;
}

.recovery-grade-status .grades .grade-status-icon.grade-color-d {
  background-color: #EA6647;
}

.recovery-grade-status .grades .grade-status-icon.grade-color-e {
  background-color: #AE3B49;
}

.recovery-grade-status .grades .grade-status-icon.grade-color-f {
  background-color: #733B3F;
}

.recovery-grade-status .body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.recovery-grade-status .body h4 {
  font-family: "WWF",sans-serif;
  font-size: 24px;
  text-transform: uppercase;
}

.recovery-grade-status .body .description {
  width: 90%;
  text-align: center;
  font-family: Arial;
  font-size: 16px;
  line-height: 140%;
  margin: 0;
}

.recovery-grade-status button {
  background-color: #000000;
  color: #ffffff;
  font-family: "WWF",sans-serif;
  font-size: 32px;
  text-transform: uppercase;
  width: 285px;
  height: 70px;
  cursor: pointer;
}

@media screen and (max-width: 680px) {
  .recovery-grade-status .header h2 {
    font-size: 28px;
  }

  .recovery-grade-status .header .subtitle {
    font-size: 16px;
    padding: 0 29px;
    text-align: center;
  }

  .recovery-grade-status .grades {
    flex-wrap: wrap;
    padding: 0 40px;
    justify-content: center;
  }

  .recovery-grade-status .body h4 {
    width: 80%;
    text-align: center;
  }

  .recovery-grade-status button {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// RecoveryGradeStatus.vue?34cbf76c